import styled, { css } from "styled-components"; 

const OrderDetailsWrapper = styled.div`
    width: 100%;
    border: ${props => props.theme.lightGrayBorder};
    border-radius: 0.5rem;
    padding: 2rem;
    padding-bottom: 0;
    margin-bottom: 1rem;
`;


const OrderDetailsHeader = styled.div`
    padding: 2rem 0;
    margin: 0 2rem;
    border-bottom: ${props => props.theme.lightGrayBorder};
    display: flex;
    justify-content: space-between;
    
`;

const OrderDetailsContent = styled.div`
    padding: 3.5rem 2rem 0;
`;

const OrderDetailsTitle = styled.h6`
    font-size: 1.6rem;
    margin-bottom: 0.7rem;
`;

const OrderDetailsSubTitle = styled.p`
color: ${props => props.theme.lightGray4};
font-family:  ${props => props.theme.fontBold};
font-weight: bold;
margin-bottom: 1rem;

${props =>
    props.first &&
    css`
       min-width: 9rem;
    `}
`;

const OrderDetailsCont = styled.div`
    padding-bottom: 5rem;
`;

const OrderDetailsContInner = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding-top: 1rem;
    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        flex-direction: row;
    }
`;

const TransactionsButtonsWrapper = styled.div`
    margin-top: 3.5rem;
    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        display: flex;
    }
`;



export { OrderDetailsWrapper, OrderDetailsHeader, OrderDetailsContent, OrderDetailsTitle, OrderDetailsSubTitle, OrderDetailsCont, OrderDetailsContInner, TransactionsButtonsWrapper }